import { render, staticRenderFns } from "./RemoveFolder.vue?vue&type=template&id=6ef37eab"
import script from "./RemoveFolder.vue?vue&type=script&lang=js"
export * from "./RemoveFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports